export const WIDGET_URL = 'https://jobboersencheck.de/widget/kuCgnFVZ4pwaPbq2.js?bottom=100&amp;rate_only=1'
export const WIDGET_TIMEOUT = 60000
export const WIDGET_MAX_JOB_VIEWS = 3
export const WIDGET_COOKIE = 'jobboersencheckWidget'
export const YF_STORAGE_START_TIME = 'yf-rating-widget-start-time'
export const YF_STORAGE_REMAINING_TIMEOUT = 'yf-rating-widget-remaining-timeout'
